import { useState, useEffect } from "react";
import { TextField, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import {
  PosFieldActions,
  resetForm,
  setDialog,
} from "../../../../app/slices/posField";
import { HiOutlineBriefcase, HiOutlineDocumentText } from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../../components/FormDialog";

const PosFieldForm = () => {
  const dispatch = useDispatch();

  const _PosField = useSelector((state) => state.posField.posField);
  const _SearchBody = useSelector((state) => state.posField.searchBody);

  const [loading, setLoading] = useState(false);

  const isAdd = _PosField.form.id ? false : true;
  const { control, reset, handleSubmit } = useForm({
    defaultValues: _PosField.form,
  });

  const onSubmit = (data) => {
    setLoading(true);
    if (isAdd) {
      dispatch(
        PosFieldActions.create(
          {
            name: data.name,
            note: data.note,
          },
          _SearchBody
        )
      )
        .then((x) => setLoading(false))
        .catch((e) => setLoading(false));
    } else {
      dispatch(
        PosFieldActions.update(
          data.id,
          {
            name: data.name,
            note: data.note,
          },
          _SearchBody
        )
      )
        .then(() => setLoading(false))
        .catch((e) => setLoading(false));
    }
  };

  useEffect(() => {
    reset({ ..._PosField.form });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_PosField.form]);

  useEffect(() => {
    return () => {
      dispatch(resetForm());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDialog = () => {
    dispatch(setDialog());
  };

  return (
    <FormDialog
      open={_PosField.dialog}
      onClose={handleDialog}
      icon={<HiOutlineBriefcase />}
      title={isAdd ? "إضافة نشاط تجاري" : "تعديل النشاط التجاري"}
      subtitle={
        isAdd
          ? "أدخل معلومات النشاط التجاري لإضافته"
          : "قم بتحديث معلومات النشاط التجاري ثم احفظ التغييرات"
      }
      onSubmit={handleSubmit(onSubmit)}
      saving={loading}
      loading={_PosField.loading}
    >
      <SectionCard
        icon={<HiOutlineDocumentText />}
        title="معلومات النشاط التجاري"
      >
        <Grid item xs={12}>
          <Controller
            name="name"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="الاسم"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default PosFieldForm;
